"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayContainer = exports.Backdrop = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const Backdrop = exports.Backdrop = _styledComponents.default.div.withConfig({
  displayName: "styles__Backdrop",
  componentId: "sc-15zlqqh-0"
})(["position:absolute;top:0;left:0;width:100%;height:100%;background-color:", ";opacity:0;transition-timing-function:cubic-bezier(0.4,0,0.2,1);transition-duration:0.35s;transition-property:opacity;"], ({
  theme
}) => theme.colors.overlay.bg);
const OverlayContainer = exports.OverlayContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__OverlayContainer",
  componentId: "sc-15zlqqh-1"
})(["position:fixed;top:0;left:0;z-index:300;display:flex;width:100vw;height:100vh;flex-direction:column;align-content:center;align-items:center;justify-content:center;pointer-events:none;", ";"], ({
  active,
  theme
}) => active && `
    pointer-events: all;

    ${Backdrop} {
      opacity: ${theme.colors.overlay.opacity};
    }
  `);